module.exports = "<section class=\"maps\">\r\n    <iframe ng-if=\"vm.mapUrlsLoaded\" id=\"map\" class=\"map\" scrolling=\"no\" src=\"{{vm.url}}\" frameborder=\"0\" allowfullscreen prevent-scroll></iframe>\r\n</section>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./app/shared/directives/road_elements/road-elements-map.directive.html
 ** module id = 93
 ** module chunks = 0
 **/